export default function blinkElement(element, blinkClass = 'flash', timeout = 1002) {
  element.classList.add(blinkClass);
  setTimeout(() => {
    element.classList.remove(blinkClass);
  }, timeout);
}
